/**
 * @generated SignedSource<<f3fb3c43b7d0472a0542b0d0603f3217>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "formFieldId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userMessage"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "formFieldId",
        "variableName": "formFieldId"
      },
      {
        "kind": "Variable",
        "name": "resourceId",
        "variableName": "resourceId"
      },
      {
        "kind": "Variable",
        "name": "userMessage",
        "variableName": "userMessage"
      }
    ],
    "concreteType": "ContinueOralInterviewPayload",
    "kind": "LinkedField",
    "name": "continueOralInterview",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "needsAuthentication",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ValidationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "messages",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "MutationResult",
        "abstractKey": "__isMutationResult"
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assistantAudioBase64",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assistantAudioContentType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AnswerOralInterview",
        "kind": "LinkedField",
        "name": "answer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "individualSummary",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OralInterviewMessage",
            "kind": "LinkedField",
            "name": "messages",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContinueOralInterviewMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContinueOralInterviewMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "40f2d972f14664a73a0be6ac0f95e663",
    "id": null,
    "metadata": {},
    "name": "ContinueOralInterviewMutation",
    "operationKind": "mutation",
    "text": "mutation ContinueOralInterviewMutation(\n  $resourceId: ID!\n  $formFieldId: ID!\n  $userMessage: String\n) {\n  continueOralInterview(resourceId: $resourceId, formFieldId: $formFieldId, userMessage: $userMessage) {\n    ... on MutationResult {\n      __isMutationResult: __typename\n      success\n      notice\n      needsAuthentication\n      errors {\n        field\n        messages\n      }\n    }\n    assistantAudioBase64\n    assistantAudioContentType\n    answer {\n      id\n      content\n      individualSummary\n      status\n      messages {\n        role\n        text\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "0be31d904259151809af4f971c9e32af";

module.exports = node;
